// extracted by mini-css-extract-plugin
module.exports = {"section":"z_l","sectionHeader":"z_bb","summary":"z_by"};